import React, { useEffect, useState } from 'react';
import { InView } from 'react-intersection-observer';

type YotpoReview = {
    productId: string;
    productName: string;
};

declare global {
    interface Window {
        yotpoWidgetsContainer: {
            initWidgets?(): void;
        };
    }
}

export const YotpoReview = ({ productId, productName }: YotpoReview) => {
    const [isLoaded, setIsLoaded] = useState(false);

    //Reset yotpo widget on product change
    useEffect(() => {
        setIsLoaded(false);
    }, [productId]);

    useEffect(() => {
        if (window?.yotpoWidgetsContainer?.initWidgets !== undefined && isLoaded) {
            window.yotpoWidgetsContainer.initWidgets();
        }
    }, [isLoaded]);

    return (
        <InView
            rootMargin="300px 0px"
            threshold={0}
            as="div"
            onChange={(inView) => {
                if (inView) setIsLoaded(true);
            }}
        >
            {isLoaded && (
                <div
                    className="yotpo-widget-instance"
                    data-yotpo-instance-id="647101"
                    data-yotpo-product-id={productId}
                    data-yotpo-name={productName}
                ></div>
            )}
        </InView>
    );
};
